import React from 'react';
import RegisterForm from '../../components/auth/RegisterForm';

const RegisterPage: React.FC = () => {
  return <RegisterForm />;
};

export default RegisterPage;
